import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { NAV_UPGRADE_SOURCE } from '../../constants/UpgradePageConstants';
import { getSavedLockedFeatureUpgradeKey } from './localStorageUtils';
export const _getUMSUpgradeKey = upgradeSource => {
  // If the upgrade source is the global nav bar, we want to use the saved upgrade key if available
  if (upgradeSource === NAV_UPGRADE_SOURCE) {
    const savedUpgradeKey = getSavedLockedFeatureUpgradeKey();
    return savedUpgradeKey || upgradeSource;
  }
  return upgradeSource;
};
export const _getUMSUpgradeKeyFromQueryParams = () => {
  const queryParams = getQueryParams();
  const upgradeSource = queryParams.upgradeSource;
  return _getUMSUpgradeKey(upgradeSource);
};